<div id="chart">
  <apx-chart
    [series]="chartOptions.series"
    [chart]="chartOptions.chart"
    [dataLabels]="chartOptions.dataLabels"
    [plotOptions]="chartOptions.plotOptions"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="chartOptions.yaxis"
    [title]="chartOptions.title"
    [colors]="chartOptions.colors"
    [tooltip]="chartOptions.tooltip"
  ></apx-chart>
</div>
